import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial, useStylesAutoBlack,
} from '../../../../St/Reports/UseStyle';
import { sto } from '../../../../Context/InshData';
import { useTranslation } from 'react-i18next';


export default function EmployeeSalarySearchForm(props) {

    const {
        rptParams,
        onChangeData,
        onChangeAutoData,
        AutoOptions,
        branches,
        employee,
        IsSalary,
        typePays,
        costCenters
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAutoBlack();
    const clasTF = useStylesTF();
    const { t } = useTranslation(["forms"]);


    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={sto.User_typei == 1 ? branches : AutoOptions?.Branches}
                        disabled={sto.User_typei == 1 ? false : true}
                        style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                id="user"
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateT"
                        label={t("voucher-no")}
                        type="number"
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        name="id" value={rptParams.id}
                        onChange={onChangeData("id")} />
                </Grid>

                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="datef"
                        label={t("date-from")}
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="date" format="YYYY-MM-DD"
                        name="dateFrom" value={rptParams.dateFrom}
                        onChange={onChangeData("dateFrom")} />
                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="datef"
                        label={t("date-to")}
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="date" format="YYYY-MM-DD"
                        name="dateTo" value={rptParams.dateTo}
                        onChange={onChangeData("dateTo")} />
                </Grid>
                {IsSalary ?
                    (
                        <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                            <TextField fullWidth variant="outlined" size="small" id="dateT"
                                label={t("net-salary")}
                                type="number"
                                className={clasTF.rootCust}
                                InputProps={{ className: claslbl.clrBlackTxt }}
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                name="salary_net" value={rptParams.salary_net}
                                onChange={onChangeData("salary_net")} />
                        </Grid>
                    ) :
                    (
                        <>
                            <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small" id="dateT"
                                    label={t("amount")}
                                    type="number"
                                    className={clasTF.rootCust}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                    name="amount" value={rptParams.amount}
                                    onChange={onChangeData("amount")} />
                            </Grid>
                            <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small" id="dateT"
                                    label={t("greater-than")}
                                    type="number"
                                    className={clasTF.rootCust}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                    name="amountFrom" value={rptParams.amountFrom}
                                    onChange={onChangeData("amountFrom")} />
                            </Grid>
                            <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small" id="dateT"
                                    label={t("less-than-or-equal")}
                                    type="number"
                                    className={clasTF.rootCust}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                    name="amountTo" value={rptParams.amountTo}
                                    onChange={onChangeData("amountTo")} />
                            </Grid>
                        </>
                    )}


                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        value={rptParams.emp}
                        onChange={(event, newValue) => {
                            onChangeAutoData("emp", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={employee}
                        style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                id="user"
                                {...params}
                                label={t("employee")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}
                    />

                </Grid>


                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.center}
                        onChange={(event, newValue) => {
                            onChangeAutoData("center", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={costCenters}
                        style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                id="center"
                                {...params}
                                label={t("cost-center")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.type}
                        onChange={(event, newValue) => {
                            onChangeAutoData("type", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={typePays}
                        style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                id="user"
                                {...params}
                                label={t("payment-type")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateT"
                        label={t("note")}
                        type="text"
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        name="notes" value={rptParams.notes}
                        onChange={onChangeData("notes")} />
                </Grid>




            </Grid>

        </React.Fragment>

    );

}